import { useEffect } from "react";

interface MediaViewerProps {
  url: string;
  name: string;
  type?: "photo" | "video";
  onClose: () => void;
}

/** Full-screen photo/video preview with a darkened backdrop -- clicking the
 *  backdrop (not the video's own controls) or pressing Escape closes it.
 *  Originally image-only (ported from BackFriend_FullStack's ImageViewer),
 *  extended to play video so clicking any thumbnail -- photo or video --
 *  pops up the same way. */
export function MediaViewer({ url, name, type = "photo", onClose }: MediaViewerProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="image-viewer-backdrop" onClick={onClose}>
      {type === "video" ? (
        <video src={url} title={name} className="image-viewer-img" controls autoPlay onClick={(e) => e.stopPropagation()} />
      ) : (
        <img src={url} alt={name} title={name} className="image-viewer-img" />
      )}
    </div>
  );
}
